module.exports = __webpack_public_path__ + "img/bg_igs.c495acbf.jpg";